import type { Resource } from "i18next";
import i18next from "i18next";
import HttpApi from "i18next-http-backend";
import Cookie from "js-cookie";
import { initReactI18next } from "react-i18next";

import {
  COOKIE_LOOKUP_KEY_LANG,
  defaultLocale,
  languageToLocaleMap,
  SUPPORTED_LOCALES,
} from "./constants";

export const getCurrentLocale = () => {
  const userPreferredLocale = Cookie.get(COOKIE_LOOKUP_KEY_LANG);

  if (!userPreferredLocale) {
    return null;
  }

  // Backwards compatibility with 2 characters locale:
  if (userPreferredLocale.length === 2) {
    return languageToLocaleMap[userPreferredLocale];
  }

  return userPreferredLocale;
};

export function initI18n({
  basepath,
  resources,
}: {
  basepath?: string;
  resources?: Resource;
}) {
  i18next
    .use(initReactI18next)
    .use(HttpApi)
    .init({
      lng: getCurrentLocale(),
      supportedLngs: SUPPORTED_LOCALES,
      fallbackLng: defaultLocale,
      debug: false,
      react: {
        useSuspense: false,
      },
      ...(resources
        ? {
            resources,
          }
        : {
            backend: {
              loadPath: `${basepath}/locales/{{lng}}.json`,
            },
          }),
    });
}
